export type LayerVisibility = "hidden" | "grid" | "both";

export const DEFAULT_LAYER_VISIBILITY: LayerVisibility = "hidden";

export const layerVisibilityToFlags = (v: LayerVisibility): { GridMap: boolean; KeyMap: boolean } => ({
  GridMap: v !== "hidden",
  KeyMap: v === "both",
});
